import { isEmail } from "../../utils/global.utils";

export const forgotPasswordValidate = ({ email }) => {
  const errors = {};
  if (!email) {
    errors.email = "* Required";
  } else if (!isEmail(email)) {
    errors.email = "Invalid email";
  }

  return errors;
};
